<template>
	<v-card flat class="mb-3">
		<v-toolbar flat dense color="primary">
			<v-toolbar-title class="title white--text">{{title}} <v-icon color="white" v-if="refreshing">fa-spin fa-spinner</v-icon></v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<div class="caption mb-3 info--text">Click a point to view details</div>
			<counts-hourly-chart :chart-data="chartData" :options="options" :height="80" />
		</v-card-text>
	</v-card>
</template>

<script>
import { DateTime } from "luxon";
import CountsHourlyChart from "./counts-hourly-chart";
import api from "../../api";

export default {
	props: {
		date: DateTime,		// NOT UTC
		region: String,
	},
	components: {
		CountsHourlyChart,
	},
	data() {
		return {
			refreshing: false,
			chartComplete: [],
			chartErrors: [],
			options: {
				onClick: (evt, item) => {
					if (!item[0]) {
						return;
					}
					this.$emit("hour-click", item[0]._index);
				},
				legend: {
					display: false,
				},
			},
		};
	},
	created() {
		this.refresh();
	},
	watch: {
		date() {
			this.$nextTick(this.refresh);
		},
		timeZone() {
			this.refresh();
		},
	},
	computed: {
		title() {
			return this.date.toLocaleString();
		},
		chartData() {
			return {
				labels: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10",
					"11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
				datasets: [
					{
						label: "Completed",
						backgroundColor: "#4CAF50",
						pointBackgroundColor: "#4CAF50",
						borderColor: "#C8E6C9",
						data: this.chartComplete,
						fill: false,
						pointRadius: 5,
						pointHoverRadius: 10,
						pointHoverBorderWidth: 10,
						pointHoverBorderColor: "#C8E6C9",
						pointHoverBackgrounColor: "#4CAF50",
					},
					{
						label: "Errors",
						backgroundColor: "#F44336",
						pointBackgroundColor: "#F44336",
						borderColor: "#FFCDD2",
						data: this.chartErrors,
						fill: false,
						pointRadius: 5,
						pointHoverRadius: 10,
						pointHoverBorderWidth: 10,
						pointHoverBorderColor: "#FFCDD2",
						pointHoverBackgrounColor: "#F44336",
					},
				],
			};
		},
	},
	methods: {
		refresh() {
			this.refreshing = true;
			api.hourlyCounts({ date: this.date.toISO(), region: this.region, offset: this.dtnow().offset }).then((r) => {
				const complete = r.data.completed;
				const completeArray = (new Array(24)).fill(0);
				complete.forEach((i) => {
					completeArray[i.hour] = i.count;
				});
				this.chartComplete = completeArray;
				const errors = r.data.errors;
				const errorArray = (new Array(24)).fill(0);

				errors.forEach((i) => {
					errorArray[i.hour] = i.count;
				});
				this.chartErrors = errorArray;
				this.refreshing = false;
			}).catch((e) => {
				this.showError(e);
			});
		},
	},
};
</script>
